import { useState, useEffect } from "react";
import axios from "axios"

import GridUsuarios from "./components/Grid-usuarios.js";
import GridModulo from "./components/Grid-modulo.js";
import GridPagina from "./components/Grid-pagina.js";

import GlobalStyle from "../../../styles/global3.js";
import styled from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import { IoMdArrowRoundBack } from "react-icons/io";
import { toast, ToastContainer } from "react-toastify";

import fundo from "../../../styles/fundo.svg";
import { MdKeyboardDoubleArrowDown } from "react-icons/md";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";

const DivLayout = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;

const Container = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  box-sizing: border-box;
  margin-top: 10px;
`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 5.5rem;
  background-image: url(${fundo});
`;

const Title2 = styled.h2`
  width: 100%;
  color: #fff;
  font-size: 28px;
  display: flex;
  justify-content: space-around; 
  align-items: center;

  img{

    padding-top: 1%;
  }  
`;


const Div = styled.div`
  position: fixed;
  top:0;
  left:0;
  display: flex;
  flex-direction: column;
`;
const Div2 = styled.div`
  display: flex;
  flex-direction: row;
  div{

    display: flex;
    flex-direction: column;
    justify-content: center; 
    margin-left: 25px;
    align-items: center;
  } 

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
const Input = styled.input`
  width: 120px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  
`;
const Label = styled.label`
  color: #fff;
  font-weight: bold;
  font-size: 17px;  
`;



const Filtro = styled.div`
  width: 100%;
  max-height: 85vh; 
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center; 
  align-items: center;
  margin: 10px
`;




const ButtonSide1 = styled.button`
  cursor: pointer;
  border: none;
  background-color: #076633;
  color: #fff;
  font-size: 18px;

  &.toggle-btn {
    position: absolute;
    top: 2;
    left: 0;
    padding-left: 1vw;
  }

  &.button-exit{
    position: absolute;
    top: 2;
    right: 0;
    padding-right: 1vw;
  }

`;


const Button = styled.button`
  padding: 5px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  width: auto;
  color: white;
  height: auto;
  font-weight: bold;
  font-size: 18px;
  margin: 5px 20px;
  transition: transform 0.3s;
  background: #575757; /* Fundo verde translúcido */
  border: none; /* Borda verde translúcida */
  border-radius: 5px; /* Bordas arredondadas */
  backdrop-filter: blur(10px); /* Efeito de desfoque */
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); /* Sombra leve */
  transition: transform 0.1s, background 0.3s, border 0.3s;
  


`;

const ButtonSelecao = styled.button`
  width: 98%;
  padding: 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  margin: auto;
  color: #575757;
  height: auto;
  font-weight: bold;
  font-size: 18px;
  margin: 0px 20px;
  transition: transform 0.3s;
  background: #fff; /* Fundo verde translúcido */
  border: none; /* Borda verde translúcida */
  border-radius: 5px; /* Bordas arredondadas */
  backdrop-filter: blur(10px); /* Efeito de desfoque */
  box-shadow: 0px 0px 2px #ccc;
  transition: transform 0.1s, background 0.3s, border 0.3s;
  display: flex;
  justify-content: space-between;
  flex-direction: row;


`;


function Usuarios() {

  //-------------------------------------------------------------------------------------------------//

  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;
  const urlGestao = `${urlFront}gestao/`;

  //-------------------------------------------------------------------------------------------------//

  const token = localStorage.getItem('token');
  const id = localStorage.getItem('id');


  //--------------------------------------------BOTÂO VOLTAR-----------------------------------------------------//


  //Links
  const handleDashboard = () => {
    window.location.href = urlGestao;
  };

  //----------------------------------------------TOKEN---------------------------------------------------//

  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  useEffect(() => {
    const getToken = async () => {
      try {
        const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
        setToken(res.data);
      } catch (error) {
        if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
          window.location.href = `${urlFront}login`;
        } else {
          console.error("Erro ao obter token:", error);
        }
      }
    };
    getToken();

  }, [token])

  //----------------------------------------DATA PARA INPUT---------------------------------------------------------//

  const hoje = new Date();
  const primeiroDiaAno = new Date(hoje.getFullYear(), 0, 1).toISOString().split('T')[0];
  const ultimoDia = hoje.toISOString().split('T')[0]; // dia atual

  //-------------------------------------------------------------------------------------------------//
  const [startDate, setStartDate] = useState(primeiroDiaAno);
  const [endDate, setEndDate] = useState(ultimoDia);




  //-------------------------------------------------------------------------------------------------//

  //Get retorna os acessos
  const [tUsuario, setUsuario] = useState("");
  const [acessoModulo, setAcessoModulo] = useState("");
  const [acessoPagina, setAcessoPagina] = useState("");

  const getAcessosUsuario = async () => {
    try {
      const res = await axios.post(`${urlApi}gestao/acessos-gerais-usuario`,
        { startDate, endDate },
        {
          headers: { Authorization: `Bearer ${token}` },
        });

      setUsuario(res.data);

      const resModulo = await axios.post(`${urlApi}gestao/acessos-gerais-modulo`,
        { startDate, endDate },
        {
          headers: { Authorization: `Bearer ${token}` },
        });

      setAcessoModulo(resModulo.data);

      const resPagina = await axios.post(`${urlApi}gestao/acessos-gerais-pagina`,
        { startDate, endDate },
        {
          headers: { Authorization: `Bearer ${token}` },
        });

      setAcessoPagina(resPagina.data);

    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }
  };


  //-------------------------------------------VERIFICA SE O USUARIO LOGADO PODE ACESSAR------------------------------------------------------//


  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const acessos = res.data;

        // Verifica se o usuário tem acesso ao módulo 0 com tipo A
        const possuiAcessoAoModulo0 = acessos.some(
          (acesso) => acesso.COD_MODULO === 1 && (acesso.TIPO_ACESSO === "G" || acesso.TIPO_ACESSO === "A")
        );

        if (!possuiAcessoAoModulo0) {
          // Redireciona se não tiver o acesso necessário
          window.location.href = '/login';
        }

      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
        window.location.href = '/login'; // Redireciona também em caso de erro (opcional)
      }
    };

    if (token && id) {
      fetchAcessos();
    }
  }, [token, id]);






  const handleConsultarAcessos = () => {
    getAcessosUsuario();

  };




  const [showModulo, setShowModulo] = useState(false);
  const [showPagina, setShowPagina] = useState(false);
  const [showUsuarios, setShowUsuarios] = useState(false);

  //-------------------------------------------------------------------------------------------------//
  return (
    <>



      <div >
        <DivLayout>
          <Title>
            <div>
              <ButtonSide1 className="toggle-btn desativaBotao" onClick={handleDashboard} style={{ backgroundColor: "transparent" }}>
                <IoMdArrowRoundBack size={28} />
              </ButtonSide1>
            </div>
            <Title2>
              <div>
                <h2>Acessos</h2>
              </div>

              <Div2>
                <div>
                  <Label>Data de Início:</Label>
                  <Input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                  />
                </div>

                <div>
                  <Label>Data de Fim:</Label>
                  <Input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                  />
                </div>

                {/* Botão para enviar a requisição */}
                <Button onClick={handleConsultarAcessos}>Consultar Acessos</Button>
              </Div2>

            </Title2>

          </Title>


        </DivLayout>


        {tUsuario ? (
          <Container>
            <Filtro>
              <ButtonSelecao onClick={() => setShowModulo(!showModulo)}>
                <span>Acessos por Módulos</span><span>{showPagina ? <MdKeyboardDoubleArrowUp /> : <MdKeyboardDoubleArrowDown />}</span>
              </ButtonSelecao>
              {showModulo && <GridModulo acessoModulo={acessoModulo} />}
            </Filtro>

            <Filtro>
              <ButtonSelecao onClick={() => setShowPagina(!showPagina)}>
                <span>Acessos por Páginas</span><span>{showPagina ? <MdKeyboardDoubleArrowUp /> : <MdKeyboardDoubleArrowDown />}</span>
              </ButtonSelecao>
              {showPagina && <GridPagina acessoPagina={acessoPagina} />}
            </Filtro>

            <Filtro>
              <ButtonSelecao onClick={() => setShowUsuarios(!showUsuarios)}>
                <span>Acessos por Usuários</span><span>{showPagina ? <MdKeyboardDoubleArrowUp /> : <MdKeyboardDoubleArrowDown />}</span>
              </ButtonSelecao>
              {showUsuarios && <GridUsuarios usuariosFiltrados={tUsuario} />}
            </Filtro>
          </Container>

        ) : (
          null
        )};
        <Div>

          <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
          <GlobalStyle />
        </Div>
      </div>
    </>
  );
}

export default Usuarios;
